const getTaskTypeProp = (taskType, names) => {
  if (!taskType) {
    return undefined;
  }

  for (let index = 0; index < names.length; index += 1) {
    if (Object.prototype.hasOwnProperty.call(taskType, names[index])) {
      return taskType[names[index]];
    }
  }

  return undefined;
};

const parseBoolean = (value) => {
  if (value === true || value === false) {
    return value;
  }

  if (typeof value === 'number') {
    return value === 1;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
  }

  return false;
};

export const isNotificationTaskType = (taskType) =>
  parseBoolean(
    getTaskTypeProp(taskType, [
      'isNotification',
      'IsNotification',
    ]),
  );

export const filterTaskTypesForTasksPage = (taskTypes) =>
  Array.isArray(taskTypes)
    ? taskTypes.filter((taskType) => !isNotificationTaskType(taskType))
    : [];
